export type AdvisoryUiAction = BasketOptimizerAccordionToggled;

export interface BasketOptimizerAccordionToggled {
  type: 'BASKET_OPTIMIZER_ACCORDION_TOGGLED';
  tabId: string;
}
export function toggleBasketOptimizerAccordion(tabId: string): BasketOptimizerAccordionToggled {
  return {
    type: 'BASKET_OPTIMIZER_ACCORDION_TOGGLED',
    tabId,
  };
}
